// import React from "react";
// import { Download, Layers3, Plus, Tags, Waypoints } from "lucide-react";
// import { motion } from "framer-motion";
// import PageHero from "../components/common/PageHero";
// import StatGrid from "../components/common/StatGrid";
// import DataTableCard from "../components/common/DataTableCard";

// export default function Activities() {
//   return (
//     <div className="erp-page-grid">
//       <PageHero
//         badge="Lot control"
//         title="Traceability-first lot management in a simpler interface."
//         subtitle="Create, split, merge and track lots with cleaner movement visibility and less visual noise."
//         actions={
//           <>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Download size={15} /> Export labels
//             </motion.button>
//             <motion.button
//               className="erp-btn erp-btn-primary"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Plus size={15} /> Create lot
//             </motion.button>
//           </>
//         }
//       />

//       <StatGrid
//         items={[
//           {
//             title: "Open lots",
//             value: "49",
//             meta: "Across all stages",
//             trend: "+6 today",
//             tone: "neutral",
//             icon: Layers3,
//           },
//           {
//             title: "Trace complete",
//             value: "97%",
//             meta: "Split and merge links healthy",
//             trend: "Strong",
//             tone: "success",
//             icon: Waypoints,
//           },
//           {
//             title: "Labels printed",
//             value: "184",
//             meta: "This shift",
//             trend: "Live",
//             tone: "success",
//             icon: Tags,
//           },
//           {
//             title: "Exception lots",
//             value: "3",
//             meta: "Need manual attention",
//             trend: "Review",
//             tone: "warning",
//             icon: Download,
//           },
//         ]}
//       />

//       <div className="erp-grid erp-grid-2">
//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Lifecycle path</h3>
//               <p>
//                 Every lot action feels more structured and easier to follow.
//               </p>
//             </div>
//           </div>
//           <div className="erp-timeline">
//             {[
//               [
//                 "Create lot",
//                 "Lot master created with source batch and input weight.",
//               ],
//               [
//                 "Split / merge",
//                 "Branch lots tracked with direct parent-child linking.",
//               ],
//               [
//                 "Stage transit",
//                 "Every move writes time, worker and floor ownership.",
//               ],
//               ["Final close", "Output and loss lock the commercial history."],
//             ].map(([title, text]) => (
//               <div key={title} className="erp-timeline-item">
//                 <div className="erp-timeline-dot" />
//                 <div>
//                   <strong>{title}</strong>
//                   <p>{text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Traceability quality</h3>
//               <p>
//                 Confidence view for labels, lineage and return trace linking.
//               </p>
//             </div>
//           </div>
//           <div className="erp-progress-stack">
//             {[
//               [
//                 "Parent-child linking",
//                 95,
//                 "Nearly all lot branches are correctly connected.",
//               ],
//               [
//                 "Label scan coverage",
//                 88,
//                 "Scanning is strong, but can still be improved.",
//               ],
//               [
//                 "Settlement trace",
//                 74,
//                 "Approval-return linking needs tighter discipline.",
//               ],
//             ].map(([title, value, text]) => (
//               <div key={title} className="erp-progress-card">
//                 <div className="erp-progress-top">
//                   <strong>{title}</strong>
//                   <span>{value}%</span>
//                 </div>
//                 <div className="erp-progress-line">
//                   <span style={{ width: `${value}%` }} />
//                 </div>
//                 <p>{text}</p>
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>

//       <DataTableCard
//         title="Recent lot movements"
//         subtitle="Latest create, split, merge and stage transitions in a clean operational grid."
//         columns={[
//           { key: "date", label: "Date" },
//           { key: "lot", label: "Lot" },
//           { key: "action", label: "Action" },
//           { key: "from", label: "From" },
//           { key: "to", label: "To" },
//           { key: "status", label: "Status" },
//         ]}
//         rows={[
//           {
//             date: "18-04-2026",
//             lot: "LOT-2401",
//             action: "Split",
//             from: "Main batch",
//             to: "Branch A / Branch B",
//             status: <span className="erp-pill success">Tracked</span>,
//           },
//           {
//             date: "18-04-2026",
//             lot: "LOT-2408",
//             action: "Transit",
//             from: "Ghat",
//             to: "MM",
//             status: <span className="erp-pill neutral">In motion</span>,
//           },
//           {
//             date: "17-04-2026",
//             lot: "LOT-2399",
//             action: "Merge",
//             from: "Branch X / Branch Y",
//             to: "Final set",
//             status: <span className="erp-pill warning">Verify label</span>,
//           },
//         ]}
//       />
//     </div>
//   );
// }




import React from "react";
import { useSearchParams } from "react-router-dom";

// 👉 sub pages


// 👉 UI
import { Download, Plus } from "lucide-react";
import { motion } from "framer-motion";
import PageHero from "../components/common/PageHero";
import StatGrid from "../components/common/StatGrid";
import DataTableCard from "../components/common/DataTableCard";
import OutwardManagement from "./Activity/OutwardManagement";
import InwardManagement from "./Activity/InwardManagerment";
import StepPage from "./Activity/StepPage";
export default function Activities() {
  const [searchParams, setSearchParams] = useSearchParams();
 const view = searchParams.get("view") || "cutting";

if (view) {
  return <StepPage stepName={view} />;
}

  // ✅ If match → render subpage
  // if (componentMap[view]) {
  //   return componentMap[view];
  // }

  // ✅ Default Dashboard
  return (
    <div className="erp-page-grid">
      <PageHero
        badge="Lot control"
        title="Traceability-first lot management"
        subtitle="Create, split, merge and track lots."
        actions={
          <>
            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
              onClick={() => setSearchParams({ view: "export-labels" })}
            >
              <Download size={15} /> Export labels
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-primary"
              whileTap={{ scale: 0.97 }}
              onClick={() => setSearchParams({ view: "create-lot" })}
            >
              <Plus size={15} /> Create lot
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
              onClick={() => setSearchParams({ view: "list" })}
            >
              View Lots
            </motion.button>
          </>
        }
      />

      {/* Stats */}
      <StatGrid
        items={[
          { title: "Open lots", value: "49" },
          { title: "Trace complete", value: "97%" },
          { title: "Labels printed", value: "184" },
          { title: "Exception lots", value: "3" },
        ]}
      />

      {/* Table */}
      <DataTableCard
        title="Recent lot movements"
        columns={[
          { key: "date", label: "Date" },
          { key: "lot", label: "Lot" },
          { key: "action", label: "Action" },
        ]}
        rows={[
          { date: "18-04-2026", lot: "LOT-2401", action: "Split" },
          { date: "18-04-2026", lot: "LOT-2408", action: "Transit" },
        ]}
      />
    </div>
  );
}